// /pages/MaintenanceHistory/AddMaintenancePage.tsx
import React, { useEffect, useState } from 'react';
import { Box, Card, CardBody, CardHeader, Heading, Spinner, Center } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { TruckMaintenanceForm } from '@/components/forms/TruckMaintenanceForm';
import { apiClient } from '@/lib/api/client';

export default function AddMaintenancePage() {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [truckData, setTruckData] = useState<{ plate_number: string } | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchTruck = async () => {
            try {
                const response = await apiClient.get(`/trucks/get-truck-by-id/${id}`);
                setTruckData(response.data);
            } catch (error) {
                console.error("Error fetching truck details:", error);
            } finally {
                setIsLoading(false);
            }
        };
        if (id) fetchTruck();
    }, [id]);

    return (
        <AdminLayout>
            {/* 🌟 Removed maxW="800px" to allow full-page width */}
            <Box p={4} w="100%">
                <Card variant="outline" boxShadow="sm" borderRadius="lg">
                    <CardHeader borderBottom="1px solid" borderColor="gray.100" py={5}>
                        <Heading size="md" color="blue.600">Add Maintenance Record</Heading>
                    </CardHeader>
                    
                    <CardBody py={8}>
                        {isLoading || !truckData ? (
                            <Center py={10}><Spinner color="blue.500" size="xl" /></Center>
                        ) : (
                            <TruckMaintenanceForm 
                                truckId={Number(id)} 
                                plateNumber={truckData.plate_number} 
                                onSuccess={() => navigate(`/fleet-management/maintenance-history/${id}`)}
                                onCancel={() => navigate(-1)}
                            />
                        )}
                    </CardBody>
                </Card>
            </Box>
        </AdminLayout>
    );
}